<template>
  <aside class="right-sidebar">
    <!-- 실제 내용 -->
    <div>
      <div class="sidebar-header">
        <router-link to="/mypage" class="menu-link">마이페이지</router-link>
      </div>
      <div class="sidebar-header">
        <router-link to="/mypage/faq" class="menu-link">고객센터</router-link>
      </div>

      <div class="sidebar-menu">
        <div class="menu-item">
          <i class="bi bi-receipt"></i>
          <span><router-link to="/quote-order" class="menu-link">견적서주문</router-link></span>
        </div>

        <div class="menu-item">
          <i class="bi bi-clipboard-plus"></i>
          <span><router-link to="/mypage/quote-requests/new" class="menu-link">상품등록요청</router-link></span>
        </div>

<!--        <div class="menu-item">-->
<!--          <div v-if="cartItemCount > 0" class="icon-badge">{{ cartItemCount }}</div>-->
<!--          <i class="bi bi-chat-dots"></i>-->
<!--          <span><router-link to="/cart" class="menu-link">장바구니</router-link></span>-->
<!--        </div>-->

        <div class="menu-item">
          <i class="bi bi-truck"></i>
          <span><router-link to="/mypage/delivery" class="menu-link">배송조회</router-link></span>
        </div>
      </div>

      <!-- 🔥 최근 본 상품 -->
      <div class="product-showcase">
        <h4>최근 본 상품</h4>
        <div v-if="recentProducts.length > 0" class="product-slide">
          <div class="product-item" @click="goToProduct(currentProduct.id)">
            <img :src="currentProduct.image" :alt="currentProduct.name" class="product-image">
            <div class="product-info">
              <div class="product-name">{{ truncateText(currentProduct.name, 20) }}</div>
              <div class="product-price">
                <span v-if="currentProduct.salePrice && currentProduct.salePrice < currentProduct.price" class="sale-price">
                  {{ formatPrice(currentProduct.salePrice) }}원
                </span>
                <span v-else class="regular-price">
                  {{ formatPrice(currentProduct.price) }}원
                </span>
              </div>
            </div>
          </div>

          <!-- 🔥 슬라이드 컨트롤 -->
          <div class="slide-controls">
            <button @click="prevProduct" class="slide-btn" :disabled="recentProducts.length <= 1">
              <i class="bi bi-chevron-left"></i>
            </button>
            <div class="slide-indicator">{{ currentIndex + 1 }}/{{ recentProducts.length }}</div>
            <button @click="nextProduct" class="slide-btn" :disabled="recentProducts.length <= 1">
              <i class="bi bi-chevron-right"></i>
            </button>
          </div>
        </div>

        <!-- 🔥 최근 본 상품이 없을 때 -->
        <div v-else class="no-recent-products">
          <p>최근 본 상품이 없습니다</p>
        </div>
      </div>

      <div class="social-icons">
        <a href="#" class="social-icon naver">N</a>
        <a href="#" class="social-icon kakao">
          <img src="@/assets/user/icon/free-icon-kakao-talk-3669973.svg" alt="kakao" class="social-svg-icon">
        </a>
        <a href="#" class="social-icon youtube">
          <img src="@/assets/user/icon/free-icon-youtube-3670209.svg" alt="Youtube" class="social-svg-icon">
        </a>
        <a href="#" class="social-icon instagram">
          <img src="@/assets/user/icon/free-icon-instagram-4138124.svg" alt="Instagram" class="social-svg-icon">
        </a>
      </div>
    </div>
  </aside>
</template>

<script>
import { recentProductsManager } from '@/utils/recentProducts.js';
import { getCart } from '@/services/cartService';

export default {
  name: 'RightSidebar',
  data() {
    return {
      recentProducts: [],
      currentIndex: 0,
      cartItemCount: 0
    }
  },
  computed: {
    currentProduct() {
      return this.recentProducts.length > 0 ? this.recentProducts[this.currentIndex] : null;
    }
  },
  mounted() {
    this.loadRecentProducts();
    this.loadCartItemCount();

    // 🔥 최근 본 상품 업데이트 이벤트 리스너
    window.addEventListener('recent-products-updated', this.handleRecentProductsUpdate);

    // 🔥 장바구니 업데이트 이벤트 리스너
    window.addEventListener('cart-updated', this.loadCartItemCount);
  },
  beforeUnmount() {
    // 이벤트 리스너 정리
    window.removeEventListener('recent-products-updated', this.handleRecentProductsUpdate);
    window.removeEventListener('cart-updated', this.loadCartItemCount);
  },
  methods: {
    // 🔥 최근 본 상품 로드
    loadRecentProducts() {
      this.recentProducts = recentProductsManager.getRecentProducts();
      this.currentIndex = 0; // 첫 번째 상품으로 초기화
    },

    // 🔥 최근 본 상품 업데이트 이벤트 핸들러
    handleRecentProductsUpdate(event) {
      this.recentProducts = event.detail.products;
      this.currentIndex = 0; // 새 상품이 추가되면 첫 번째로 이동
    },

    // 🔥 이전 상품
    prevProduct() {
      if (this.recentProducts.length <= 1) return;
      this.currentIndex = this.currentIndex === 0 ? this.recentProducts.length - 1 : this.currentIndex - 1;
    },

    // 🔥 다음 상품
    nextProduct() {
      if (this.recentProducts.length <= 1) return;
      this.currentIndex = this.currentIndex === this.recentProducts.length - 1 ? 0 : this.currentIndex + 1;
    },

    // 🔥 상품 상세 페이지로 이동
    goToProduct(productId) {
      this.$router.push(`/product/${productId}`);
    },

    // 🔥 텍스트 자르기
    truncateText(text, maxLength) {
      if (!text) return '';
      return text.length > maxLength ? text.substring(0, maxLength) + '...' : text;
    },

    // 🔥 가격 포맷팅
    formatPrice(price) {
      if (!price) return '0';
      return Number(price).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    },

    // 🔥 장바구니 아이템 개수 로드
    async loadCartItemCount() {
      try {
        const token = localStorage.getItem('auth_token');
        if (!token) {
          this.cartItemCount = 0;
          return;
        }

        // Header 와 동시에 요청하므로 진행 중인 요청을 공유
        const cart = await getCart();
        this.cartItemCount = cart?.items?.length || 0;
      } catch (error) {
        console.error('장바구니 개수 로드 실패:', error);
        this.cartItemCount = 0;
      }
    }
  }
}
</script>

<style scoped>
.right-sidebar {
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 10px 0;
  width: 100%;
  max-width: 80px;
}

/* 기존 스켈레톤 UI 스타일들... */
.skeleton-sidebar {
  width: 100%;
  animation: pulse 1.5s infinite;
}

@keyframes pulse {
  0% {
    opacity: 0.6;
  }
  50% {
    opacity: 1;
  }
  100% {
    opacity: 0.6;
  }
}

.skeleton-header {
  width: 100%;
  height: 30px;
  background-color: #e0e0e0;
  margin-bottom: 5px;
}

.skeleton-header:first-child {
  background-color: #b3e5fc;
}

.skeleton-menu {
  width: 100%;
  padding: 10px 0;
}

.skeleton-item {
  width: 40px;
  height: 55px;
  background-color: #e0e0e0;
  margin: 15px auto;
  border-radius: 4px;
}

.skeleton-showcase {
  width: 100%;
  padding: 10px 0;
}

.skeleton-title {
  width: 60%;
  height: 12px;
  background-color: #e0e0e0;
  margin: 0 auto 10px auto;
  border-radius: 2px;
}

.skeleton-product {
  width: 90%;
  height: 80px;
  background-color: #e0e0e0;
  margin: 0 auto;
  border-radius: 4px;
}

.skeleton-social {
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  margin-top: 15px;
}

.skeleton-icon {
  width: 30px;
  height: 30px;
  background-color: #e0e0e0;
  border-radius: 50%;
  margin: 5px;
}

/* 실제 컨텐츠 스타일 */
.sidebar-header {
  width: 100%;
  text-align: center;
  padding: 10px 0;
  font-weight: bold;
  font-size: 14px;
}

.sidebar-header:first-child {
  background-color: #00BCD4;
  color: white;
}

.sidebar-header:nth-child(2) {
  background-color: #555;
  color: white;
}

.sidebar-menu {
  width: 100%;
  padding: 10px 0;
}

.menu-item {
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 10px 0;
  position: relative;
}

.menu-item i {
  font-size: 24px;
  margin-bottom: 5px;
}

.menu-item span {
  font-size: 12px;
}

.menu-link {
  color: inherit;
  text-decoration: none;
}

.icon-badge {
  position: absolute;
  top: 0;
  right: 10px;
  background-color: #00BCD4;
  color: white;
  border-radius: 50%;
  width: 20px;
  height: 20px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 10px;
}

/* 🔥 최근 본 상품 스타일 */
.product-showcase {
  margin-top: 20px;
  width: 100%;
  padding: 0 5px;
}

.product-showcase h4 {
  font-size: 12px;
  margin-bottom: 10px;
  text-align: center;
  color: #333;
}

.product-slide {
  position: relative;
}

.product-item {
  cursor: pointer;
  border-radius: 4px;
  overflow: hidden;
  transition: transform 0.2s;
  background: white;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
}

.product-item:hover {
  transform: scale(1.02);
}

.product-image {
  width: 100%;
  height: 60px;
  object-fit: cover;
  display: block;
}

.product-info {
  padding: 5px;
  text-align: center;
}

.product-name {
  font-size: 10px;
  color: #333;
  margin-bottom: 3px;
  line-height: 1.2;
}

.product-price {
  font-size: 9px;
}

.sale-price {
  color: #ff4757;
  font-weight: bold;
}

.regular-price {
  color: #333;
}

.slide-controls {
  display: flex;
  align-items: center;
  justify-content: center;
  margin-top: 5px;
  gap: 5px;
}

.slide-btn {
  background: none;
  border: 1px solid #ddd;
  border-radius: 50%;
  width: 20px;
  height: 20px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  font-size: 10px;
  color: #666;
}

.slide-btn:hover:not(:disabled) {
  background-color: #f0f0f0;
}

.slide-btn:disabled {
  opacity: 0.3;
  cursor: not-allowed;
}

.slide-indicator {
  font-size: 10px;
  color: #666;
  min-width: 30px;
  text-align: center;
}

.no-recent-products {
  text-align: center;
  padding: 20px 10px;
}

.no-recent-products p {
  font-size: 11px;
  color: #999;
  margin: 0;
}

/* 소셜 아이콘 스타일 */
.social-icons {
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  margin-top: 15px;
}

.social-icon {
  width: 30px;
  height: 30px;
  border-radius: 50%;
  margin: 5px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: white;
  font-weight: bold;
  text-decoration: none;
}

.social-icon.naver {
  background-color: #03C75A;
}

.social-icon.kakao {
  background-color: #FEE500;
  color: #000;
}

.social-icon.youtube {
  background-color: #FF0000;
}

.social-icon.instagram {
  background: linear-gradient(45deg, #f09433, #e6683c, #dc2743, #cc2366, #bc1888);
}

.social-svg-icon {
  width: 20px;
  height: 20px;
  vertical-align: middle;
}

@media (max-width: 768px) {
  .right-sidebar {
    display: none;
  }
}
</style>